import { useEffect } from 'react';

const AutoUpdateManager = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Use the registration from index.js if available, otherwise get it
      const setupUpdateListener = (registration) => {
        // Check for updates periodically
        const checkForUpdate = () => {
          registration.update();
        };
        
        // Check for updates every 5 minutes
        const updateInterval = setInterval(checkForUpdate, 5 * 60 * 1000);
        
        // Listen for update found events
        const handleUpdateFound = () => {
          const newWorker = registration.installing;
          if (newWorker) {
            const handleStateChange = () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New version available, updating automatically...');
                
                // Clear all caches to force fresh content
                const performUpdate = async () => {
                  try {
                    if ('caches' in window) {
                      const cacheNames = await caches.keys();
                      await Promise.all(
                        cacheNames.map(cacheName => {
                          console.log('Clearing cache:', cacheName);
                          return caches.delete(cacheName);
                        })
                      );
                    }
                    
                    // Since the service worker already has skipWaiting, 
                    // just reload the page to get the new version
                    // Use a small delay to ensure the new SW is active
                    setTimeout(() => {
                      window.location.reload(true);
                    }, 100);
                  } catch (error) {
                    console.error('Error during automatic update:', error);
                    // Fallback to simple reload
                    window.location.reload(true);
                  }
                };
                
                // Perform the update automatically
                performUpdate();
              }
            };
            
            newWorker.addEventListener('statechange', handleStateChange);
          }
        };
        
        registration.addEventListener('updatefound', handleUpdateFound);
        
        // Initial check for updates
        checkForUpdate();
        
        // Cleanup function
        return () => {
          clearInterval(updateInterval);
          registration.removeEventListener('updatefound', handleUpdateFound);
        };
      };
      
      // Check if we have a global registration from index.js
      if (window.swRegistration) {
        setupUpdateListener(window.swRegistration);
      } else {
        // Otherwise wait for the service worker to be ready
        navigator.serviceWorker.ready.then(setupUpdateListener);
      }
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default AutoUpdateManager;
